<template>
    <v-navigation-drawer 
        app 
        v-model="drawer"
        color="#1F283E" 
        expand-on-hover
        rail
        width="350"
        floating
        permanent
        style="color: aliceblue;"
        >
        <v-list-item
          prepend-avatar="/logo.png" 
          title="GEC & GED PNB"
          nav
          height="50"
        ></v-list-item>

        <v-divider></v-divider>

        <!-- Menu Components Sidebar -->
        <MenuDrawer />
        
    </v-navigation-drawer>
</template>

<script>
    import MenuDrawer from "@/components/layout/MenuDrawer"

    export default {
        name: 'NavDrawer',
        components: {
            MenuDrawer,
        },
        data () {
            return {
                drawer: true,
                rail: true,
            }
        },
    }
</script>